import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {ActivatedRoute, Router} from "@angular/router";
import {
    EnumStudioType,
    ExperienceLevelType,
    IAppStatic,
    Id,
    IPlayerProps,
    IResource,
    ISceneBlock,
    IUser
} from "../../../interfaces";
import {
    faArrowUpRightDots, faAsterisk,
    faCalendarCheck,
    faCertificate,
    faImage,
    faLayerGroup,
    faLocationCrosshairs,
    faMinusCircle,
    faPhotoFilm,
    faPlusCircle,
    faPuzzlePiece,
    faIcons
} from "@fortawesome/free-solid-svg-icons";
import {
    AccessService,
    AppService,
    AuthUserService, ContainerService,
    LocalStoreService,
    StoreSelectorsService
} from "../../../services";
import {delay, filter, map, switchMap, tap} from "rxjs/operators";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {actionNetworkRequest} from "../../../store/actions/user.actions";
import {ofType} from "@ngrx/effects";
import {ActionsSubject} from "@ngrx/store";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {isNullOrUndef, popupWindow} from "../../../common";
import {combineLatest, Observable} from "rxjs";
import {animate, style, transition, trigger} from "@angular/animations";
import {Lib} from "../../../../libs/Lib";
import {MatAccordion} from '@angular/material/expansion';
import {TwitterComponent} from "../../../components/twitter/twitter.component";
import {
    SceneAddComponentDialog
} from "../scene-add-block/scene-add-component-dialog/scene-add-component-dialog";
import {AiService} from "../../../services/ai/ai.service";

@Component({
    selector: 'app-scene-nav',
    styleUrls: [`./scene-nav.component.scss`],
    templateUrl: './scene-nav.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger("grow", [ // Note the trigger name
            transition(":enter", [
                // :enter is alias to 'void => *'
                style({height: "0", overflow: "hidden"}),
                animate(500, style({height: "*"}))
            ]),
            transition(":leave", [
                // :leave is alias to '* => void'
                animate(500, style({height: 0, overflow: "hidden"}))
            ])
        ])]
})


export class SceneNavComponent extends Compbaser implements AfterViewInit, OnInit {

    @Input() minimized = false;
    @Input() slideEditMode = false;
    @Output() whenMinimized: EventEmitter<any> = new EventEmitter();
    @Output() whenMaximized: EventEmitter<any> = new EventEmitter();
    @Output() routerClick: EventEmitter<any> = new EventEmitter();

    @ViewChild("networkStatusModal", {read: TemplateRef}) networkStatusModal: TemplateRef<any>;
    @ViewChild(MatAccordion) accordion: MatAccordion;


    @ViewChild('layersTemplate') layersTemplate!: TemplateRef<any>;
    @ViewChild('componentsTemplate') componentsTemplate!: TemplateRef<any>;
    @ViewChild('scenesTemplate') scenesTemplate!: TemplateRef<any>;
    @ViewChild('resourcesTemplate') resourcesTemplate!: TemplateRef<any>;
    @ViewChild('schedulersTemplate') schedulersTemplate!: TemplateRef<any>;
    @ViewChild('stickersTemplate') stickersTemplate!: TemplateRef<any>;
    @ViewChild('animationTemplate') animationTemplate!: TemplateRef<any>;
    @ViewChild('backgroundsTemplate') backgroundsTemplate!: TemplateRef<any>;
    @ViewChild('iconsTemplate') iconsTemplate!: TemplateRef<any>;
    activeTemplate = 'components';


    activeSceneId: Id;
    networkCall = false;
    user: IUser;
    enableDynawebs = false;
    enterpriseMode: boolean;
    dashboardMode: boolean;
    upgradable: boolean;
    selected = 'domain';
    appStatic: IAppStatic;
    fasterqEnabled = '0';
    showHelpEnabled = '0';
    eventsEnabled = '0';
    scheduledEnabled = '0'; //alon
    dashboardEnabled = '0'; //alon
    paintEnabled = '0';
    enableDashboard = '0'; //??? alon
    catalogEnabled = '0';
    transitionsEnabled = '0';
    musicEnabled = '0';
    liveChatStatus = false;
    studioType: EnumStudioType;
    addSceneItem: ISceneBlock;
    selectedSceneId;
    m_currentViewMode = 'nav';
    isMimeMainPlayer = false;
    spun = 0;
    activePanel = 0;
    isFullFeatures: boolean;

    navMain$: Observable<string>;
    navEnterprise$: Observable<string>;
    navUser$: Observable<string>;
    navChat$: Observable<string>;
    navSearch$: Observable<string>;

    signStudioDashboard$: Observable<string>;
    signStudioEditor$: Observable<string>;
    signStudioResources$: Observable<string>;
    signStudioProducts$: Observable<string>;
    signStudioDownloads$: Observable<string>;
    signStudioHelp$: Observable<string>;
    signStudioPlayers$: Observable<string>;
    signStudioPainter$: Observable<string>;
    signStudioScheduler$: Observable<string>;
    signStudioFasterQ$: Observable<string>;
    signStudioMusic$: Observable<string>;
    signStudioCatalog$: Observable<string>;
    signStudioEvents$: Observable<string>;
    signStudioTransitions$: Observable<string>;
    signStudioAdnet$: Observable<string>;
    signStudioSettings$: Observable<string>;
    showAccount = true;

    EnumStudioType = EnumStudioType;
    readonly faPlusCircle = faPlusCircle;
    readonly faMinusCircle = faMinusCircle;
    readonly faLayerGroup = faLayerGroup;
    readonly faPuzzlePiece = faPuzzlePiece;
    readonly faLocationCrosshairs = faLocationCrosshairs;
    readonly faPhotoFilm = faPhotoFilm;
    readonly faAsterisk = faAsterisk;
    readonly faArrowUpRightDots = faArrowUpRightDots;
    readonly faCalendarCheck = faCalendarCheck;
    readonly faCertificate = faCertificate;
    readonly faImage = faImage;
    readonly faIcons = faIcons;
    // readonly faCube = faCube;
    // readonly faSitemap = faSitemap;
    // readonly faTachometerAlt = faTachometerAlt;
    // readonly faIndent = faIndent;

    private scriptAttr: string | any = "twttr";


    dialogCompAddRef: MatDialogRef<SceneAddComponentDialog>;

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    constructor(private router: Router,
                private storeSelector: StoreSelectorsService,
                private route: ActivatedRoute,
                private authUserService: AuthUserService,
                private actionsSubj: ActionsSubject,
                private translocoService: TranslocoService,
                private toastr: ToastrService,
                private localStoreService: LocalStoreService,
                private cd: ChangeDetectorRef,
                private accessService: AccessService,
                public override dialog: MatDialog,
                private appService: AppService,
                private element: ElementRef,
                private containerService: ContainerService,
                private aiService: AiService
    ) {
        super();

        // this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navChat ? value.$.navChat : '1'))
        //     .subscribe((v) => {
        //         console.log(v);
        // });
        // this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navSearch ? value.$.navSearch : '1'))
        //     .subscribe((v) => {
        //         console.log(v);
        // });

        this.cod(
            this.actionsSubj.pipe(ofType(actionNetworkRequest))
                .pipe(
                    delay((111)),
                    tap(val => {
                        this.networkCall = true;
                        this.cd.markForCheck();
                    }),
                    delay((1111)),
                    tap(val => {
                        this.networkCall = false;
                        this.cd.markForCheck();
                    })
                )
                .subscribe((reply) => {
                })
        );
        this.cod(
            this.storeSelector.listenSelectedSceneId().subscribe((_sceneId: Id) => {
                this.activeSceneId = _sceneId;
            })
        );
        this.cod(
            this.storeSelector.getUser().subscribe((i_user) => {
                this.studioType = i_user.studioType;
            })
        );
        this.cod(
            this.storeSelector.getLiveChatStatusV2().subscribe((i_status) => {
                if (i_status.liveStatusV2 > 0 !== this.liveChatStatus) this.cd.markForCheck();
                this.liveChatStatus = i_status.liveStatusV2 > 0;
            })
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                    this.fasterqEnabled = this.localStoreService.getStorageValConfig('fasterqEnabled');
                    this.showHelpEnabled = this.localStoreService.getStorageValConfig('showHelpEnabled');
                    this.catalogEnabled = this.localStoreService.getStorageValConfig('catalogEnabled');
                    this.eventsEnabled = this.localStoreService.getStorageValConfig('eventsEnabled');
                    this.scheduledEnabled = this.localStoreService.getStorageValConfig('scheduledEnabled');
                    this.dashboardEnabled = this.localStoreService.getStorageValConfig('dashboardEnabled');
                    this.paintEnabled = this.localStoreService.getStorageValConfig('paintEnabled');
                    this.enableDashboard = this.localStoreService.getStorageValConfig('enableDashboard');
                    this.transitionsEnabled = this.localStoreService.getStorageValConfig('transitionsEnabled');
                    this.musicEnabled = this.localStoreService.getStorageValConfig('musicEnabled');
                    this.cd.markForCheck();
                })
        );
        this.cod(
            this.storeSelector.getLocalStoreUpdates()
                .subscribe((updates) => {
                })
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );
        this.cod(
            this.storeSelector.getUser().pipe(
                switchMap((i_user: IUser) => {
                    this.user = i_user;
                    this.enableDynawebs = i_user.username.indexOf('@mediasignage.com') > -1;
                    this.enterpriseMode = i_user.enterprise;
                    this.dashboardMode = i_user.dashboard;
                    this.upgradable = Lib.IsAccountUpgradable2(i_user);  // Alon test
                    return this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig');

                })
            ).subscribe((e) => {
                this.experienceLevel = this.dashboardMode ? ExperienceLevelType.ADVANCED : this.localStoreService.getStorageValConfig('experienceLevel'); // Alon

                const intermediateUrls = ["/paint/list", "/catalog/list", "/scheduler/editor", "/statistics", "/download"];
                if (intermediateUrls.includes(this.router.url) && this.experienceLevel == ExperienceLevelType.BEGINNER) {
                    this.router.navigate(['/home']);
                }

                const advancedUrls = ["/events/list", "/transitions/list", "/music/list", "/fasterq/list"];
                if (advancedUrls.includes(this.router.url) && this.experienceLevel < ExperienceLevelType.ADVANCED) {
                    this.router.navigate(['/home']);
                }
                this.cd.markForCheck();
            })
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                })
        );

        this.cod(
            this.aiService.sceneNav$.subscribe( page => {
                this.setActiveTemplate(page);
            })
        );

    }

    logout(): void {
        if (this.activeSceneId) {
            this.appService.updateMultiScene([this.activeSceneId], true);
            setTimeout(() => {
                this.authUserService.logout();
                this.appService.goToHomePage(false);
            }, 3000);
        } else {
            setTimeout(() => {
                this.authUserService.logout();
                this.appService.goToHomePage(false);
            }, 1000);
        }
    }

    ngOnInit(): void {
        this.cod(
            // combineLatest([this.storeSelector.listenSelectedSceneId(), this.storeSelector.listenScenes()])
            //     .pipe(
            //         filter((v: any) => {
            //             if (!isNullOrUndef(v[0]) && v[1].length) {
            //                 if (this.m_currentViewMode != 'scene' && !this.slideEditMode) {
            //                     this.whenMaximized.emit();
            //                 }
            //                 this.m_currentViewMode = 'scene';
            //                 return true;
            //             } else {
            //                 if (this.m_currentViewMode != 'nav' && !this.slideEditMode) {
            //                     this.whenMaximized.emit();
            //                     this.activePanel = 0;
            //                 }
            //                 this.m_currentViewMode = 'nav';
            //                 return false;
            //             }
            //         }),
            //         map(([sceneId, i_scenes]) => {
            //             return i_scenes.find((i_scene: IPlayerProps) => {
            //                 if (i_scene.Player.$.id === sceneId) {
            //                     return true;
            //                 }
            //             });
            //         }))
            this.storeSelector.listenSelectedScene().subscribe((i_scene: IPlayerProps) => {
                if (!i_scene) return;
                this.selectedSceneId = i_scene.Player.$.id;
                this.isMimeMainPlayer = this.storeSelector.isMainSceneOrPlayer(i_scene.Player.$.mimeType);
            })
        );
    }

    ngAfterViewInit() {
        this.initAccess();
    }

    private initAccess() {
        this.accessService.getGroupsCollection("SignStudio Account")
            .pipe(map((value) => {
                return !(this.enterpriseMode && value?.$?.visible === '0');
            }))
            .subscribe((v) => {
                this.showAccount = v;
            });

        this.navMain$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navMain ? value.$.navMain : '1'));
        this.navUser$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navUser ? value.$.navUser : '1'));
        this.navChat$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navChat ? value.$.navChat : '1'));
        this.navSearch$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navSearch ? value.$.navSearch : '1'));
        this.navEnterprise$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navEnterprise ? value.$.navEnterprise : '1'));
        this.signStudioEditor$ = this.accessService.getGroupsCollection("SignStudio Editor").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioDashboard$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioResources$ = this.accessService.getGroupsCollection("SignStudio Resources").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioHelp$ = this.accessService.getGroupsCollection("SignStudio Help").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioDownloads$ = this.accessService.getGroupsCollection("SignStudio Downloads").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioProducts$ = this.accessService.getGroupsCollection("SignStudio Dashboard").pipe(map((value) => value && value.$.navProducts ? value.$.navProducts : '1'));
        this.signStudioPlayers$ = this.accessService.getGroupsCollection("SignStudio Players").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioPainter$ = this.accessService.getGroupsCollection("SignStudio Painter").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioScheduler$ = this.accessService.getGroupsCollection("SignStudio Scheduler").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioFasterQ$ = this.accessService.getGroupsCollection("SignStudio FasterQ").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioMusic$ = this.accessService.getGroupsCollection("SignStudio Music").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioSettings$ = this.accessService.getGroupsCollection("SignStudio Settings").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioCatalog$ = this.accessService.getGroupsCollection("SignStudio Catalog").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioEvents$ = this.accessService.getGroupsCollection("SignStudio Events").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioTransitions$ = this.accessService.getGroupsCollection("SignStudio Transitions").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        this.signStudioAdnet$ = this.accessService.getGroupsCollection("SignStudio Adnet").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));

        // this.signStudioAccount$ = this.accessService.getGroupsCollection("SignStudio Account").pipe(map((value) => value && value.$.visible ? value.$.visible : '1'));
        // this.accessService.getGroupsCollection("SignStudio Downloads")
        //     .pipe(map((value) => {
        //         alert(value);
        //         return value && value.$.visible ? value.$.visible : '1';
        //     }))
        //     .subscribe((v) => {
        //     });
    }

    swapTheme() {
        const v = this.localStoreService.getStorageValConfig('theme');
        this.localStoreService.setStorageValConfig('theme', v === '1' ? '0' : '1');
    }

    installPwa() {
        this.appService.installPwa();
    }

    openTwitter() {
        this.dialog.open(TwitterComponent, {
            height: '600px',
            width: '400px',
        });
    }

    async checkVersion() {
        this.toastr.info(this.translocoService.translate('general.latestVersion6', {}, this.translocoService.getActiveLang()));
        const evt = await this.appService.checkAppVersion();
        if (evt) {
            console.log('Found new version ' + evt);
            // this.appService.showReleaseNotes(evt);
        }
    }

    checkNetwork() {
        this.dialog.open(this.networkStatusModal, {
            height: '430px',
            width: '800px'
        });
    }

    goToLink(link: string) {
        // throw new Error("testing random error..." + Math.random());
        let url;
        switch (link) {
            case 'chat': {
                Lib.openLiveChat(true, this.user, this.appStatic, this.router);
                return;
            }
            case 'forum': {
                url = this.appStatic.homePage.replace('www', 'forum');
                break;
            }
            case 'home': {
                this.appService.goToHomePage(true);
                return;
            }
        }
        popupWindow({url, title: '_blank', w: 500, h: 500});
    }

    onRouterClick(): void {
        this.routerClick.emit();
    }

    upgrade() {
        this.appService.openWizardUpgradeDialog();
    }

    openComponentsDialog(): void {
        this.dialogCompAddRef = this.dialog.open(SceneAddComponentDialog, {
            width: '90%',
            height: '90%',
            panelClass: 'custom-dlg-container',
            data: {Component: 'Add'}
        });
        this.dialogCompAddRef.afterClosed().subscribe(result => {
            if (result) {
            }
        });
    }


    onMinimized() {
        this.whenMinimized.emit();
        this.minimized = true;
        this.cd.detectChanges();
    }

    onMaximized() {
        this.whenMaximized.emit();
        this.minimized = false;
    }

    onExpandPanel(panel) {
        if (this.minimized) {
            this.whenMaximized.emit();
        }
        this.minimized = false;
        setTimeout(() => {   // setTimeOut is necessary as collapse and expand event are triggered at moment
            this.activePanel = panel;
            this.cd.detectChanges();
        }, 100);
    }

    onCollapsePanel() {
        this.activePanel = 0;
        this.cd.detectChanges();
    }

    onKeyDown(event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            // event.preventDefault(); // Prevent default scroll action
            // event.stopPropagation(); // Stop further propagation
            // event.stopImmediatePropagation();
            // document.getElementById('viewSceneContainer').focus();
            if (event.target) {
                event.target.focus();
            }
        }
    }


    setActiveTemplate(templateName: string): void {
        if (this.activeTemplate != templateName) {
            this.onMaximized();
        } else {
            if (this.minimized) {
                this.onMaximized();
            } else if (!this.slideEditMode) {
                // Don't minimize in slide edit mode
                this.onMinimized();
            }
        }
        this.activeTemplate = templateName;

    }

    getTemplate(name: string): TemplateRef<any> | null {
        switch (name) {
            case 'layers':
                return this.layersTemplate;
            case 'components':
                return this.componentsTemplate;
            case 'scenes':
                return this.scenesTemplate;
            case 'resources':
                return this.resourcesTemplate;
            case 'schedulers':
                return this.schedulersTemplate;
            case 'stickers':
                return this.stickersTemplate;
            case 'animation':
                return this.animationTemplate;
            case 'backgrounds':
                return this.backgroundsTemplate;
            case 'icons':
                return this.iconsTemplate;
            default:
                return null;
        }
    }

}

// if (this.dashboardMode) {
//     this.signStudioEvents$ = this.accessService.getGroupsCollection("SignStudio Events").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
//     this.signStudioTransitions$ = this.accessService.getGroupsCollection("SignStudio Transitions").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
//     this.signStudioAdnet$ = this.accessService.getGroupsCollection("SignStudio Adnet").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
// } else {
//     this.signStudioEvents$ = this.accessService.getGroupsCollection("SignStudio Events").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
//     this.signStudioTransitions$ = this.accessService.getGroupsCollection("SignStudio Transitions").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
//     this.signStudioAdnet$ = this.accessService.getGroupsCollection("SignStudio Adnet").pipe(map((a) => a && a.$.visible ? a.$.visible : '0'));
// }
// this.$accessEditors = this.accessService.getGroupsCollection("Changelist").pipe(map((a) => a.$.visible));
// this.$accessEditors = this.accessService.getGroupsCollection("Campaigns").pipe(map((a) => a.$.visible));
// this.$accessEditors = this.accessService.getGroupsCollection("Changelist").pipe(map((a) => a.$.visible));


